let chartTypes;
export default chartTypes = {
    'msline':
    { displayName:  'multi series line', category: 'multiseries' },
    'msspline':
    { displayName:  'multi series spline', category: 'multiseries' },
    'stackedarea2d':
    { displayName:  'stacked area', category: 'multiseries' },
    'msarea':            
    { displayName:  'multi series area', category: 'multiseries' },                    
    'msstepline':
    { displayName:  'multi series step line', category: 'multiseries' },
    'mscolumn2d':
    { displayName:  'multi series column', category: 'multiseries' },
    'mscolumn3d':
    { displayName:  'multi series column 3D', category: 'multiseries' },
    'msbar2d':
    { displayName:  'multi series bar', category: 'multiseries' },
    'msbar3d': 
    { displayName:  'multi series bar 3D', category: 'multiseries' },
    'stackedcolumn2d':
    { displayName:  'stacked column', category: 'multiseries' },
    'stackedcolumn3d':
    { displayName:  'stacked column 3D', category: 'multiseries' },
    'stackedbar2d':   
    { displayName:  'stacked bar', category: 'multiseries' },
    'stackedbar3d':     
    { displayName:  'stacked bar 3D', category: 'multiseries' },                       
    'inversemscolumn2d':
    { displayName:  'inverse axis multi series column', category: 'multiseries' },
    'inversemsline':
    { displayName:  'inverse axis multi series line', category: 'multiseries' },
    'inversemsarea':
    { displayName:  'inverse axis multi series area', category: 'multiseries' },
    'logmscolumn2d':                
    { displayName:  'log axis multi series column', category: 'multiseries' },
    'logmsline':
    { displayName:  'log axis multi series line', category: 'multiseries' },
    'logstackedcolumn2d':
    { displayName:  'log axis stacked column', category: 'multiseries' },
    'pie2d':
    { displayName:  'pie', category: 'multiseries' },
    'pie3d':
    { displayName:  'pie 3D', category: 'multiseries' },
    'doughnut2d':
    { displayName:  'doughnut', category: 'multiseries' },
    'doughnut3d':
    { displayName:  'doughnut 3D', category: 'multiseries' },                
    'column2d':
    { displayName:  'column', category: 'multiseries' },                    
    'column3d':
    { displayName:  'column 3D', category: 'multiseries' },
    'bar2d':
    { displayName:  'bar', category: 'multiseries' },
    'bar3d':
    { displayName:  'bar 3D', category: 'multiseries' },                    
    'waterfall2d':
    { displayName:  'waterfall', category: 'multiseries' },
    'area2d':
    { displayName:  'area', category: 'multiseries' }
};
        
